import { format } from 'date-fns'

import type { ICPFileUploadDetails } from './CPFileUploadTypes.ts'

export const formatFileSize = (sizeInBytes: number): string => {
	const sizes = ['Bytes', 'Kb', 'Mb', 'GB', 'TB'] as string[]
	const i = parseInt(
		Math.floor(Math.log(sizeInBytes) / Math.log(1024)).toString(),
		10
	)

	return sizeInBytes
		? `${Math.round(sizeInBytes / Math.pow(1024, i))} ${sizes[i]}`
		: ''
}

export const getFileUploadTooltip = (
	name: string,
	details: ICPFileUploadDetails
): string | undefined => {
	if (!details.uploaded_at || !details.uploaded_by) return undefined

	const uploadedAt = new Date(details.uploaded_at)
	const date = format(uploadedAt, 'dd.MM.yyyy')
	const time = format(uploadedAt, 'HH:mm')
	const { name: userName, email }: { name: string; email: string } =
		details.uploaded_by
	const uploader = `${userName} (${email})`

	return [
		name,
		`Diese Datei wurde am ${date} um ${time} von ${uploader} hochgeladen.`
	].join('\n')
}
